import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';
import {
  columnsOtherData, columnsRefractometer, columnsOldRx, columnsSubjective, columnsAcomodacion,
  columnsCoverTest, columnsRetinoscopia, columnsBinocularidad, columnsPrism,
} from './testsTables';
import PIO from './pio';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { Flex } from '../../../shared/components';
import ReadOnly from '../../../shared/components/dataEntry/ReadOnly';

interface TestsProps {
  create: boolean,
  watch: boolean,
  hookForms: any
}

export default function Tests({ create, watch: watchMode, hookForms }:TestsProps) {
  const {isTablet, isDesktop} = useBreakpoint();
  const pruebas = useSelector((state:any) => state.fichaOptometricaWorkspace.graduacionSelected?.pruebas);
  const opcion_agudeza_visual = useSelector((state: any) => state.auth.permisos.configuracion.agudeza_visual_fraccionaria);
  const opcion_queratometria = useSelector((state: any) => state.auth.permisos.configuracion.querometria_con_eje);
  const {
    register, setValue, getValues, watch,
  } = hookForms;

  const pios = watch('pios');

  const mergeObjectDeep = (key: any, sourceElement:any, targetElement: any) => {
    if (typeof sourceElement[key] === 'object') {
      const result = _.mergeWith({}, targetElement[key], sourceElement[key],
        (o, s) => {
          if (_.isUndefined(o) || _.isEmpty(o)) return s;
          Object.entries(o).forEach(([key, value]) => {
            if ((_.isNull(o[key]) || _.isEmpty(o[key]) || _.isUndefined(o[key]))) {
              // eslint-disable-next-line no-param-reassign
              try {
                o[key] = s[key];
              } catch (e) {
                console.log(e);
              }
            }
          });
          return o;
        });
      // eslint-disable-next-line no-param-reassign
      targetElement[key] = result;
    } else if (!targetElement[key] && sourceElement[key]) {
      // eslint-disable-next-line no-param-reassign
      targetElement[key] = sourceElement[key];
    } else if (targetElement && (_.isEmpty(targetElement[key] || _.isNull(targetElement[key])))) {
      // eslint-disable-next-line no-param-reassign
      console.log(key, targetElement[key]);
    }
  };

  const setValuesDeep = (element: any, concatKey: string) => {
    if (_.isObject(element)) {
      if (Object.entries(element).length > 0) {
        const newElement = Object.assign(element, {});
        Object.entries(newElement).forEach(([key, value]) => {
          setValuesDeep(value, `${concatKey}.${key}`);
        });
      } else {
        setValue(concatKey, '');
      }
    } else {
      setValue(concatKey, element || '');
    }
  };

  useEffect(() => {
    if (!create && pruebas) {
      Object.entries(pruebas).forEach(
        ([key, value]) => {
          const formValues = getValues();
          if (_.isString(value) || _.isNumber(value)) {
            if (formValues[key]) setValue(key, formValues[key] || '');
            else setValue(key, value || '');
          } else {
            mergeObjectDeep(key, pruebas, formValues);
            setValuesDeep(formValues[key], key);
          }
        },
      );
    }
  }, [pruebas]);


  const otherData = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      prisma: <input
        disabled={watchMode}
        className="tableInputs"
        name="otros_datos.ojo_derecho.prisma"
        ref={register}
      />,
      queratometria: <input
        onBlur={(e:any) => selectQueratometria(e)}
        disabled={watchMode}
        className="tableInputs"
        name="otros_datos.ojo_derecho.queratometria"
        ref={register}
      />,
      cilindroCorneal: <input
        disabled={watchMode}
        className="tableInputs"
        name="otros_datos.ojo_derecho.cilindro_corneal"
        ref={register}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      prisma: <input
        disabled={watchMode}
        className="tableInputs"
        name="otros_datos.ojo_izquierdo.prisma"
        ref={register}
      />,
      queratometria: <input
        onBlur={(e:any) => selectQueratometria(e)}
        disabled={watchMode}
        className="tableInputs"
        name="otros_datos.ojo_izquierdo.queratometria"
        ref={register}
      />,
      cilindroCorneal: <input
        disabled={watchMode}
        className="tableInputs"
        name="otros_datos.ojo_izquierdo.cilindro_corneal"
        ref={register}
      />,
    },
  ];

  const refractometerData = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="refractometro.ojo_derecho.eje"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="refractometro.ojo_derecho.cilindro"
        ref={register}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="refractometro.ojo_derecho.esfera"
        ref={register}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="refractometro.ojo_izquierdo.eje"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="refractometro.ojo_izquierdo.cilindro"
        ref={register}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="refractometro.ojo_izquierdo.esfera"
        ref={register}
      />,
    },
  ];

  const oldRxData = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsferaLejos(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.esfera_lejos"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.cilindro"
        ref={register}
      />,
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.eje"
        ref={register}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_derecho', 'rx_antigua')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.esfera_cerca"
        ref={register}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.adicion"
        ref={register}
      />,
      priLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.prisma_lejos"
        ref={register}
      />,
      priCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_derecho.prisma_cerca"
        ref={register}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsferaLejos(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.esfera_lejos"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.cilindro"
        ref={register}
      />,
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.eje"
        ref={register}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_izquierdo', 'rx_antigua')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.esfera_cerca"
        ref={register}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.adicion"
        ref={register}
      />,
      priLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.prisma_lejos"
        ref={register}
      />,
      priCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="rx_antigua.ojo_izquierdo.prisma_cerca"
        ref={register}
      />,
    },
  ];

  const coverTestData = [
    {
      key: 'cerca',
      ojo: 'Cerca',
      sinCorrec: <input
        disabled={watchMode}
        className="tableInputs"
        name="cover_test.cerca.sin_correccion"
        ref={register}
      />,
      conCorrec: <input
        disabled={watchMode}
        className="tableInputs"
        name="cover_test.cerca.con_correccion"
        ref={register}
      />,
    },
    {
      key: 'lejos',
      ojo: 'Lejos',
      sinCorrec: <input
        disabled={watchMode}
        className="tableInputs"
        name="cover_test.lejos.sin_correccion"
        ref={register}
      />,
      conCorrec: <input
        disabled={watchMode}
        className="tableInputs"
        name="cover_test.lejos.con_correccion"
        ref={register}
      />,
    },
  ];

  const retinoscopiaData = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="retinoscopia.ojo_derecho.eje"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="retinoscopia.ojo_derecho.cilindro"
        ref={register}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="retinoscopia.ojo_derecho.esfera_lejos"
        ref={register}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="retinoscopia.ojo_izquierdo.eje"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="retinoscopia.ojo_izquierdo.cilindro"
        ref={register}
      />,
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="retinoscopia.ojo_izquierdo.esfera_lejos"
        ref={register}
      />,
    },
  ];

  const subjective = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_derecho.esfera_lejos"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_derecho.cilindro"
        ref={register}
      />,
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_derecho.eje"
        ref={register}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_derecho', 'subjetivo')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_derecho.esfera_cerca"
        ref={register}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_derecho.adicion"
        ref={register}
      />,
      avcc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_derecho.AVVC"
        ref={register}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      esfLejos: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_izquierdo.esfera_lejos"
        ref={register}
      />,
      cilindro: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'sign')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_izquierdo.cilindro"
        ref={register}
      />,
      eje: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, 'axis')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_izquierdo.eje"
        ref={register}
      />,
      esfCerca: <input
        onBlur={(e:any) => setTwoNumberDecimalBlurEsfCerca(e, 'ojo_izquierdo', 'subjetivo')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_izquierdo.esfera_cerca"
        ref={register}
      />,
      adicion: <input
        onBlur={(e:any) => setTwoNumberDecimalBlur(e, '')}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_izquierdo.adicion"
        ref={register}
      />,
      avcc: <input
        onBlur={(e:any) => setFormatoAgudezaVisual(e)}
        disabled={watchMode}
        className="tableInputs"
        name="subjetivo.ojo_izquierdo.AVVC"
        ref={register}
      />,
    },
  ];

  const prismData = [
    {
      key: 'dcho',
      ojo: 'Dcho.',
      horLejos: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_derecho.horizontal_lejos"
        ref={register}
      />,
      verLejos: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_derecho.vertical_lejos"
        ref={register}
      />,
      horCerca: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_derecho.horizontal_cerca"
        ref={register}
      />,
      verCerca: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_derecho.vertical_cerca"
        ref={register}
      />,
    },
    {
      key: 'izdo',
      ojo: 'Izdo.',
      horLejos: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_izquierdo.horizontal_lejos"
        ref={register}
      />,
      verLejos: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_izquierdo.vertical_lejos"
        ref={register}
      />,
      horCerca: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_izquierdo.horizontal_cerca"
        ref={register}
      />,
      verCerca: <input
        disabled={watchMode}
        className="tableInputs"
        name="binocularidad_prisma_lejos_cerca.ojo_izquierdo.vertical_cerca"
        ref={register}
      />,
    },
  ];

  const acomodacion = [
    {
      key: 'arn',
      fila: 'ARN/ARP',
      acomodacion: <input disabled={watchMode} className="tableInputs" name="acomodacion.arn_arp" ref={register} />,
    },
    {
      key: 'mem',
      fila: 'MEM',
      acomodacion: <input disabled={watchMode} className="tableInputs" name="acomodacion.mem" ref={register} />,
    },
  ];

  const binocularidad = [
    {
      key: 'crn',
      cr: 'CRN',
      lejos: <input disabled={watchMode} className="tableInputs" name="binocularidad.lejos_CRN" ref={register} />,
      cerca: <input disabled={watchMode} className="tableInputs" name="binocularidad.cerca_CRN" ref={register} />,
      esteopsis: <input disabled={watchMode} className="tableInputs" name="binocularidad.esteopsis" ref={register} />,
    },
    {
      key: 'crp',
      cr: 'CRP',
      lejos: <input disabled={watchMode} className="tableInputs" name="binocularidad.lejos_CRP" ref={register} />,
      cerca: <input disabled={watchMode} className="tableInputs" name="binocularidad.cerca_CRP" ref={register} />,
    },
  ];
  function setTwoNumberDecimal(value: any, type:string) {
    if (type === 'axis') {
      if (parseFloat(value) < 0 || parseFloat(value) > 359 || parseFloat(value) % 1 !== 0) return '';
      if (value.charAt(value.length - 1) === 'º') return value;
      return `${value}º`;
    }
    if (type === 'sign') {
      if (value.charAt(0) !== '+' && value.charAt(0) !== '-') {
        if (parseFloat(value) % 0.25 !== 0 || parseFloat(value) > 50 || parseFloat(value) < -50) return '';
        return `+${parseFloat(value).toFixed(2)}`;
      }
      if (value.charAt(0) === '+' || value.charAt(0) === '-') {
        const currentSign = value.charAt(0);
        const sub = value.substring(1);
        if (parseFloat(sub) % 0.25 !== 0 || parseFloat(value) > 50.0 || parseFloat(value) < -50.0) return '';
        return currentSign + parseFloat(sub).toFixed(2);
      }
    } else {
      return parseFloat(value).toFixed(2);
    }
  }
  function setTwoNumberDecimalBlur(e: any, type:string) {
    const regEx = /^[\d\(\)\-+.º]+$/m;
    if (regEx.test(e.target.value) === false) {
      e.target.value = '';
      return e.target.value;
    }
    if (e.target.value === '') return;
    e.target.value = setTwoNumberDecimal(e.target.value, type);
  }
  function setTwoNumberDecimalBlurEsferaLejos(e: any, type:string) {
    const regEx = /^[\d\(\)\-+.º]+$/m;
    if (regEx.test(e.target.value) === false) {
      if(e.target.value == 'C' || e.target.value == 'N'){
        return e.target.value;
      }else{
        e.target.value = '';
        return e.target.value;
      }
    }
    if (e.target.value === '') return;
    e.target.value = setTwoNumberDecimal(e.target.value, type);
  }
  function setTwoNumberDecimalBlurEsfCerca(e:any, ojo: string, type: string){
    const values = getValues();
    const datosOjo = ojo === 'ojo_derecho' ? values[type]?.ojo_derecho : values[type]?.ojo_izquierdo;
    if (!datosOjo) return;
    const {esfera_lejos} = datosOjo;
    const numberEsfLejos = parseFloat(esfera_lejos);

      if( numberEsfLejos > e.target.value){
        e.target.value = numberEsfLejos
        setTwoNumberDecimalBlur(e, 'sign');
      }else{
        setTwoNumberDecimalBlur(e, 'sign');
      }
  }
  function setNumberFractional(value:any){
    const cadena = value.split('/');
    let cadenaFinal = '';
    if(cadena.length == 2){
      cadena.forEach((element:any) => {
        if(element.length > 2){
          if(cadenaFinal == ''){
            cadenaFinal = element.substr(0,2) + '/';
          }else{
            cadenaFinal = cadenaFinal + element.substr(0,2);
          }
          }
      })
    }
    return cadenaFinal;
  }
  function setFormatoAgudezaVisual(e:any){
    if(opcion_agudeza_visual == 'S'){
      e.target.value = setNumberFractional(e.target.value);
    }else{
      setTwoNumberDecimalBlur(e, '');
    }
  }
  function selectQueratometria(e:any){
    if(opcion_queratometria == 'S'){
      e.target.value = queratometriaConEje(e.target.value);
    }else{
      e.target.value = queratometriaSinEje(e.target.value);
    }
  }
  function queratometriaConEje(e:any){
    var stringValor = String(e).replace(/\./g, "");
    stringValor = stringValor.replace(/\,/g, "");
    stringValor = stringValor.replace(/\*/g, "");
    stringValor = stringValor.replace(/\-/g, "");
    stringValor = stringValor.replace(/\_/g, "");
    //Valores de grado
    stringValor = stringValor.replace(/\º/g, "");
    stringValor = stringValor.replace(/\°/g, "");
    var valorNumerico = Number(stringValor);
    //Comprobamos si solo nos quedamos con el valor numerico
    if (valorNumerico !== undefined) {
      //El valor tiene que ser de tamaño 6, si es mejor lo rellenamos con una string vacia
      if (stringValor.length < 9)
        stringValor = stringValor + "     ";
      var valor = stringValor.substring(0, 1) + '.' + stringValor.substring(1, 2) + '*' +
          stringValor.substring(3, 1) + '.' + stringValor.substring(4, 2) + '-' +
          stringValor.substring(6, 3) + '°';
      return valor;
    }
  }
  function queratometriaSinEje(e:any){
    var stringValor = String(e).replace(/\./g, "");
    stringValor = stringValor.replace(/\,/g, "");
    stringValor = stringValor.replace(/\*/g, "");
    stringValor = stringValor.replace(/\-/g, "");
    stringValor = stringValor.replace(/\_/g, "");
    //Valores de grado
    stringValor = stringValor.replace(/\º/g, "");
    stringValor = stringValor.replace(/\°/g, "");
    var valorNumerico = Number(stringValor);
    //Comprobamos si solo nos quedamos con el valor numerico
    if (valorNumerico !== undefined) {
      //El valor tiene que ser de tamaño 6, si es mejor lo rellenamos con una string vacia
      if (stringValor.length < 6)
        stringValor = stringValor + "     ";
      var valor = stringValor.substring(0, 1) + '.' + stringValor.substring(1, 2) + '*' +
          stringValor.substring(3, 1) + '.' + stringValor.substring(4, 2);
      return valor;
    }
  }
  return (
    <>
      <Flex className="bodyInfo" style={isTablet ? {flexDirection:'column'} : {flexDirection:'row'}}>
        <div className="flexCol margin-right">
          <div className="flexRow spaceBetween">
            <h3>Otros datos</h3>
          </div>
          <ReadOnly condition={watchMode}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%' }}
              columns={columnsOtherData}
              dataSource={otherData}
              pagination={false}
            />
          </ReadOnly>
        </div>
        <div className="flexCol" style={isTablet ? { marginTop: '16px' } : {}}>
          <div className="flexRow spaceBetween">
            <h3>Refractómetro</h3>
          </div>
          <ReadOnly condition={watchMode}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%' }}
              columns={columnsRefractometer}
              dataSource={refractometerData}
              pagination={false}
            />
          </ReadOnly>
        </div>
      </Flex>
      <PIO pios={pios} watch={watchMode} setPios={(pios: any) => { setValue('pios', pios); }} />
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Observación pupilas</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <input disabled={watchMode} name="observacion_pupilas" placeholder="Escriba aquí..." className="ant-input marginTop16" type="text" ref={register} />
        </ReadOnly>
      </div>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Motilidad ocular</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <input disabled={watchMode} name="motilidad_ocular" placeholder="Escriba aquí..." className="ant-input marginTop16" type="text" ref={register} />
        </ReadOnly>
      </div>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>P.P.C</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <input disabled={watchMode} name="ppc" placeholder="Escriba aquí..." className="ant-input marginTop16" type="text" ref={register} />
        </ReadOnly>
      </div>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>RX Antigua</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <Table className="marginTop16 table" columns={columnsOldRx} dataSource={oldRxData} pagination={false} />
        </ReadOnly>
      </div>
      <Flex className="bodyInfo">
        <div className="flexCol margin-right">
          <div className="flexRow spaceBetween">
            <h3>Cover test</h3>
          </div>
          <ReadOnly condition={watchMode}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%' }}
              columns={columnsCoverTest}
              dataSource={coverTestData}
              pagination={false}
            />
          </ReadOnly>
        </div>
        <div className="flexCol margin-left">
          <div className="flexRow spaceBetween">
            <h3>Retinoscopia</h3>
          </div>
          <ReadOnly condition={watchMode}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%' }}
              columns={columnsRetinoscopia}
              dataSource={retinoscopiaData}
              pagination={false}
            />
          </ReadOnly>
          </div>
      </Flex>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Subjetivo</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <Table className="marginTop16 table" columns={columnsSubjective} dataSource={subjective} pagination={false} />
        </ReadOnly>
      </div>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Binocularidad - Prisma lejos y cerca</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <Table className="marginTop16 table" columns={columnsPrism} dataSource={prismData} pagination={false} />
        </ReadOnly>
      </div>
      <Flex className="bodyInfo">
        <div className="flexCol margin-right">
          <div className="flexRow spaceBetween">
            <h3>Binocularidad</h3>
          </div>
          <ReadOnly condition={watchMode}>
            <Table
              className="marginTop16 table"
              style={{ width: '100%' }}
              columns={columnsBinocularidad}
              dataSource={binocularidad}
              pagination={false}
            />
          </ReadOnly>
        </div>
        <div className="flexCol margin-left">
        <ReadOnly condition={watchMode}>
          <Table
            className="marginTop16 table"
            style={{ width: '100%', marginTop: 40 }}
            columns={columnsAcomodacion}
            dataSource={acomodacion}
            pagination={false}
          />
        </ReadOnly>
        </div>
      </Flex>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Impresión / Plan</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <input disabled={watchMode} name="impresion_plan" placeholder="Escriba aquí..." className="ant-input marginTop16" type="text" ref={register} />
        </ReadOnly>
      </div>
      <div className="bodyInfo flexCol">
        <div className="flexRow spaceBetween">
          <h3>Otras pruebas</h3>
        </div>
        <ReadOnly condition={watchMode}>
          <input disabled={watchMode} name="otras_pruebas" placeholder="Escriba aquí..." className="ant-input marginTop16" type="text" ref={register} />
        </ReadOnly>
      </div>
    </>

  );
}
